import * as React from 'react';
import { useMemo } from 'react';

import { IBaseQuestionProps } from '../FormContainer/types/internal';
import { TValidators } from '../../utils/useSimpleForm';
import { checkIsDigitCount, validatePrice } from './utils';
import { PRICE_VALUE_FIELD } from './constants';
import { TValue } from '../../utils/useSimpleForm/types/internal';
import { RawPriceQuestionContainer } from './RawPriceQuestionContainer';
import { useApplicationContext } from '../../utils/applicationContext';
import { EQuestionCode } from '../../types/form';

interface IPriceQuestionProps<T = TValue> extends IBaseQuestionProps {
  validators: TValidators<T>;
}
export const PriceQuestionContainer: React.FC<React.PropsWithChildren<IPriceQuestionProps>> = props => {
  const {
    question: { required, code },
  } = props;

  const applicationContext = useApplicationContext();
  const updateApplicationEnabled = applicationContext.config.get<boolean>('demand.ApplicationFormV5.Enabled') || false;

  const validators = useMemo(() => {
    if (!updateApplicationEnabled) {
      return {
        [PRICE_VALUE_FIELD]: (value: string) => validatePrice(value, required),
      };
    }

    switch (code) {
      case EQuestionCode.PriceRange:
      case EQuestionCode.Price:
        return {
          [PRICE_VALUE_FIELD]: (value: string) => validatePrice(value, required, checkIsDigitCount(5)),
        };
      case EQuestionCode.PriceWithCommunal:
      case EQuestionCode.PriceRangeWithCommunal:
      case EQuestionCode.PriceRangeWithCommunalAndOperational:
        return {
          [PRICE_VALUE_FIELD]: (value: string) => validatePrice(value, required, checkIsDigitCount(3)),
        };
      default:
        return {
          [PRICE_VALUE_FIELD]: (value: string) => validatePrice(value, required),
        };
    }
  }, [code, required, updateApplicationEnabled]);

  return <RawPriceQuestionContainer {...props} validators={validators} />;
};

PriceQuestionContainer.displayName = 'PriceQuestionContainer';
